import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var AxisLine = /*#__PURE__*/function (_Component) {
  function AxisLine() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.d3scaleExtent = function (domain) {
      var start = domain[0];
      var stop = domain[domain.length - 1];
      return start < stop ? [start, stop] : [stop, start];
    };
    _this.d3scaleRange = function (scale) {
      return scale.rangeExtent ? scale.rangeExtent() : _this.d3scaleExtent(scale.range());
    };
    return _this;
  }
  _inheritsLoose(AxisLine, _Component);
  var _proto = AxisLine.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      orient = _this$props.orient,
      strokeWidth = _this$props.strokeWidth,
      outerTickSize = _this$props.outerTickSize,
      fill = _this$props.fill,
      stroke = _this$props.stroke,
      scale = _this$props.scale;
    var sign = orient === 'top' || orient === 'left' ? -1 : 1;
    var range = this.d3scaleRange(scale);
    var d;
    if (orient === 'bottom' || orient === 'top') {
      d = "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize;
    } else {
      d = "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize;
    }
    return /*#__PURE__*/React.createElement("path", {
      className: "domain",
      d: d,
      style: {
        shapeRendering: 'crispEdges'
      },
      fill: fill,
      stroke: stroke,
      strokeWidth: strokeWidth
    });
  };
  return AxisLine;
}(Component);
AxisLine.defaultProps = {
  innerTickSize: 6,
  outerTickSize: 6,
  tickPadding: 3,
  fill: 'none',
  tickArguments: [10],
  // eslint-disable-next-line zillow/react/default-props-match-prop-types
  tickValues: null,
  // eslint-disable-next-line zillow/react/default-props-match-prop-types
  tickFormat: null
};
AxisLine.propTypes = process.env.NODE_ENV !== "production" ? {
  scale: PropTypes.func.isRequired,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  innerTickSize: PropTypes.number,
  outerTickSize: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  tickPadding: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types, zillow/react/no-unused-prop-types
  tickArguments: PropTypes.array,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  orient: PropTypes.string,
  strokeWidth: PropTypes.string
} : {};
var AxisLine$1 = AxisLine;

export { AxisLine$1 as default };
